import { cn } from '@/shared/lib/cn';

export interface PageFetchProgressProps {
  /** When true, shows the top progress bar. */
  active: boolean;
  className?: string;
}

/** Blue top bar (NProgress-style) for edit/detail data fetches. */
export function PageFetchProgress({ active, className }: PageFetchProgressProps) {
  if (!active) {
    return null;
  }

  return (
    <div
      className={cn(
        'pointer-events-none sticky top-0 z-[60] h-1 w-full overflow-hidden bg-primary/15',
        className,
      )}
      role="progressbar"
      aria-busy="true"
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="page-fetch-progress-bar h-full w-1/3 rounded-full bg-primary" />
      <style>{`
        @keyframes page-fetch-progress {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
        .page-fetch-progress-bar {
          animation: page-fetch-progress 1.1s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
